/* eslint-disable*/
/* global d3 $ _ */
/* eslint-disable-line */
//import "../../assets/lasso.css";
//import '../../vendor/chernoff.js';

import pipeService from "../../service/pipeService"
import dataService from "../../service/dataService";
let DrawRelationList = function(id){
    this.id = id
    this.divWidth = $('#' + this.id).width()
    this.divHeight = $('#' + this.id).height()
    this.margin = { top: 30, right: 10, bottom: 20, left: 10 }
    this.width = this.divWidth - this.margin.left - this.margin.right
    this.height = this.divHeight - this.margin.top - this.margin.bottom

    // this.max_rect_height = 80;
    this.rect_padding = 1.5;
}




DrawRelationList.prototype.layout = function(data, label) {

    d3.select("#" + label + "_relationTooltip").remove()
    var hoverDiv = d3.select("body").append("div")
        .attr("class", "tooltip")
        .attr("id", label + "_relationTooltip")
        .style("opacity", 0)
    
    // set the dimensions and margins of the graph
    var width = this.width,
    height = this.height - 25;

    // Relation Layout
    var max_freq = Math.max(...data.map(d=>d.freq));
    max_freq = Math.max(max_freq, 1);
    // let max_rect_height = this.max_rect_height;
    let rect_padding = this.rect_padding;

    // max_rect_height is adjusted based on height.
    let total_ratio = 0;
    for(let i = 0; i < data.length; i++){
        let curr_ratio = data[i].freq / max_freq;
        total_ratio += curr_ratio;
    }
    if (total_ratio < 1 ) total_ratio = 1;
    // Solve equation: (data.length - 1) * rect_padding + total_ratio * max_rect_height = height;
    let max_rect_height = (height - (data.length + 2) * rect_padding) / total_ratio;
    if (max_rect_height < 1) max_rect_height = 1;


    var rect_width = width;
    let curr_y = 0;
    for(let i = 0; i<data.length; i++){
        let curr_height = data[i].freq / max_freq * max_rect_height;
        let curr_width = rect_width;
        let curr_inner_width = curr_width * data[i].acc;
        data[i]["layout"] = {
            "curr_height": curr_height,
            "curr_width": curr_width,
            "curr_inner_width": curr_inner_width,
            "curr_y": curr_y 
        }
        curr_y += curr_height + rect_padding;
    }




    let relation_height = Math.max(this.divHeight, curr_y + rect_padding * 3);
    
    // append the svg object to the body of the page
    d3.select("#"+this.id +"_svg").remove();
    var svg = d3.select("#"+this.id)
        .append("svg")
        .attr("id", this.id +"_svg")
        .attr("width", this.divWidth)
        .attr("height", relation_height)
        .append("g")
        .attr("transform",
            "translate(" + this.margin.left + "," + this.margin.top + ")");
    //console.log("d3", d3);
    //Read the data

    svg.append("text")
        .attr("x", rect_width / 2)
        .attr("y", -10)
        .attr("text-anchor","middle")
        .text('Relations')


    let rect_x = 0;

    let relation_g_update = svg
        .selectAll("g.relation_g")
        .data(data);

    let relation_g = relation_g_update.enter().append("g").attr("class", "relation_g");

    relation_g.append("rect")
        .attr("x", function (d) { return rect_x; } )
        .attr("y", function (d) { return d.layout.curr_y; } )
        .attr("width", (d) => d.layout.curr_width)
        .attr("height", (d) => d.layout.curr_height)
        .style("fill", "#EEEEEE")
        .style("stroke", (d) => (d.selected) ? "#000000" : "#ffffff")
        .on('mouseover', function (d) {

            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '.7');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", ".7");
            hoverDiv.html(d.relation_name + " Accuracy: " + (d.acc).toFixed(2))
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 35) + "px");
            
            // relation_bars hover event
            let target_info = {"view": "global_view", "target": "relation_bars"}
            let additional_info = {"relation_name": d.relation_name}
            dataService.saveUserDataWrapper("hover", target_info, additional_info);
        })
        .on('mouseout', function (d, i) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '1');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", 0);
            hoverDiv.select("*").remove()
        })

    relation_g.append("rect")
        .attr("x", function (d) { return rect_x; } )
        .attr("y", function (d) { return d.layout.curr_y; } )
        .attr("width", (d) => d.layout.curr_inner_width)
        .attr("height", (d) => d.layout.curr_height)
        .style("fill", "#93C47D")
        .on('mouseover', function (d) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '.7');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", ".7");
            hoverDiv.html(d.relation_name + " Accuracy: " + (d.acc).toFixed(2))
                .style("left", (d3.event.pageX - 105) + "px")
                .style("top", (d3.event.pageY - 35) + "px");

            // relation_bars hover event
            let target_info = {"view": "global_view", "target": "relation_bars"}
            let additional_info = {"relation_name": d.relation_name}
            dataService.saveUserDataWrapper("hover", target_info, additional_info);
        })
        .on('mouseout', function (d, i) {
            d3.select(this).transition()
                 .duration('50')
                 .attr('opacity', '1');
            hoverDiv.transition()
                .duration('50')
                .style("opacity", 0);
            hoverDiv.select("*").remove()
        })


    // relation_g.append("text")
    //     .attr("x", function (d) { return rect_x; } )
    //     .attr("y", function (d) { return d.layout.curr_y + d.layout.curr_height / 2; } )
    //     .attr("dominant-baseline", "middle")
    //     .attr("font-size", "14px")
    //     .text((d) => d.relation_name + " " + (d.acc).toFixed(2) + "")


    relation_g.merge(relation_g_update).on("click", function(d,i){ 
        console.log("select relation", d, i)
        if(d.selected == true){
            pipeService.emitSelectRelation([])
        }else{
            let relation_name_list = [d.relation_name];
            
            pipeService.emitSelectRelation(relation_name_list);
            pipeService.emitSelectConcept([]);
        }
        // relation_bars click event
        let target_info = {"view": "global_view", "target": "relation_bars"}
        let additional_info = {"relation_name": d.relation_name}
        dataService.saveUserDataWrapper("click", target_info, additional_info);
    });
}

export default DrawRelationList;